import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useGetHelpCenterArticleCTA} from '../hooks/useGetHelpCenterArticle';
import {HelpCenterArticleCtaView} from './HelpCenterArticleCtaView';

export const HelpCenterArticleCta = ({
  isFullWidth,
}: {
  isFullWidth?: boolean;
}) => {
  return (
    <DataFetcher
      request={useGetHelpCenterArticleCTA()}
      View={HelpCenterArticleCtaView}
      viewProps={{isFullWidth}}
      Error={() => null}
      Loading={() => null}
    />
  );
};
